import * as React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Breadcrumbs, { breadcrumbsClasses } from "@mui/material/Breadcrumbs";
import NavigateNextRoundedIcon from "@mui/icons-material/NavigateNextRounded";
import { Link } from "react-router-dom";
import { CONFIG } from "../../config";

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: "center",
  },
}));

export default function NavbarBreadcrumbs(props) {
  const { pageTitle, packId } = props;

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
    >
      <Typography variant="body1">{CONFIG.title}</Typography>
      <Typography
        variant="body1"
        sx={{ color: "text.primary", fontWeight: 600 }}
      >
        {pageTitle}
      </Typography>
      {packId && (
        <Link
          to={`/packs/${packId}`}
          style={{ textDecoration: 'none' }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "var(--accent-ochre, #26A69A) !important",
              fontWeight: 600,
              cursor: "pointer",
              "&:hover": {
                color: "var(--accent-ochre, #00897B) !important",
                textDecoration: "underline"
              }
            }}
          >
            Pack: {packId}
          </Typography>
        </Link>
      )}
    </StyledBreadcrumbs>
  );
}
